import React, { Component } from 'react';
import analytics from 'rewind-analytics';
import axios from 'axios';

import Router from './router';

import { topics, topicData } from './data';

const Context = React.createContext({});

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      statsLoading: true,
      modalOpen: false,
      optionSelected: null,
      introVideoWatched: false,
      statData: {},
      scenariosComplete:[],
    }
  }

  componentDidMount() {
    analytics.init({
      projectName: 'spend-it-like-stormont',
      secondaryProject: 'spend-it-like-stormont-prod'
    });

    // Get stats
    this.getStats();

    // Update every 10 mins
    this.statTimer = setInterval(() => {
      this.getStats();
    }, 600000);
  }

  componentWillUnmount(){
    clearInterval(this.statTimer);
  }

  getStats() {
    var self = this;
    // Fetch data from AWS API
    axios.get(`https://axutefwx6k.execute-api.us-east-1.amazonaws.com/dev/stats/secondaryProject/spend-it-like-stormont-prod`)
      .then(({ data }) => {
        // Extract the required data for the current view
        self.setState({ statsLoading: false, statData: data });
      });
  }

  getContext() {
    const self = this;

    return {
      statsLoading: self.state.statsLoading,
      topics: topics,
      topicData: topicData,
      modalOpen: self.state.modalOpen,
      toggleModal: (selectedOption) => self.setState({ modalOpen: !self.state.modalOpen, optionSelected: selectedOption }),
      optionSelected: self.state.optionSelected,
      resetSelectedOption: () => self.setState({ modalOpen: false, optionSelected: null }),
      markVideoWatched: (value) => self.setState({ introVideoWatched: value }),
      introVideoWatched: self.state.introVideoWatched,
      statData: self.state.statData,
      scenariosComplete: self.state.scenariosComplete,
      completeScenario: (scenario) => self.state.scenariosComplete.indexOf(scenario) === -1 && self.setState(prevState => ({
        scenariosComplete: [...prevState.scenariosComplete, scenario]
      })),
    }
  }

  render() {
    return (
      <Context.Provider value={this.getContext()}>
        <Router />
      </Context.Provider>
    );
  }
}

export function withContext(Component) {
  return props => (
    <Context.Consumer>
      {context => <Component {...props} context={context} />}
    </Context.Consumer>
  );
}

export default App;